import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationMethodComponent } from './verification-method/verification-method.component';
import { TokenConfirmationComponent } from './token-confirmation/token-confirmation.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { AccountRecoveryComponent } from './account-recovery/account-recovery.component';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialAngularModule } from '../material-design/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { ComponentsModule } from '../shared/components/components.module';
import { RouterModule } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';

@NgModule({
  declarations: [
    VerificationMethodComponent,
    TokenConfirmationComponent,
    PasswordChangeComponent,
    AccountRecoveryComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    MaterialAngularModule,
    FormsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    ComponentsModule,
    RouterModule,
    ReactiveFormsModule,
    NgOtpInputModule,
  ],
  exports: [
    VerificationMethodComponent,
    TokenConfirmationComponent,
    PasswordChangeComponent,
    AccountRecoveryComponent
  ]
})
export class PasswordRecoveryModule { }
